import { TYPE_RHYTHM_EVENT_ENUM } from '@/shared/config';
import RrInterval from './rrInterval';
import ArtifactAreas from './artifactAreas';
import AfibEvents from './afibEvents';
import useWrapReport from './useWrapReport';

/**
 * Switchboard for the Beats tab body, showing artifact areas, AFib events or the RR interval view. Reads the active event button and the empty-data flag from useWrapReport and renders whichever of the three views matches.
 *
 * @returns The report view matching the active event button.
 */
const WrapReport = () => {
  const { activeButton, isEmptyData } = useWrapReport();

  /**
   * Picks which beat report view belongs under the currently active event button. Returns the artifact areas view for ARTIFACT, the AFib events view for AFIB and the RR interval view for everything else, forwarding the empty-data flag to the first two.
   *
   * @returns The report view matching the active event button.
   */
  const renderContent = () => {
    switch (activeButton) {
      case TYPE_RHYTHM_EVENT_ENUM.ARTIFACT: {
        return <ArtifactAreas isEmptyData={isEmptyData} />;
      }
      case TYPE_RHYTHM_EVENT_ENUM.AFIB: {
        return <AfibEvents activeButton={activeButton} isEmptyData={isEmptyData} />;
      }
      default: {
        return <RrInterval />;
      }
    }
  };

  return renderContent();
};

export default WrapReport;
